import $ from 'jquery';

const NavbarSticker = {
  el: $('.empreendimento__navbar'),
  elBreakPoint: $('.empreendimento__capa'),
  init: () => {
    if ($(NavbarSticker.el).length) {
      $(window).on('scroll', NavbarSticker.scroll);
    }
  },
  isActive: () => $(NavbarSticker.el).css('position') === 'absolute',
  offset: () => $(NavbarSticker.elBreakPoint).outerHeight() - 5,
  scroll: () => {
    if ($(window).scrollTop() >= NavbarSticker.offset()) {
      $(NavbarSticker.el).addClass('is-scroll');
    } else {
      $(NavbarSticker.el).removeClass('is-scroll');
    }
  },
};

export default NavbarSticker;
